var map = {
	"./abused.svg": 959,
	"./admiration.svg": 960,
	"./affection.svg": 961,
	"./agony.svg": 962,
	"./alarm.svg": 963,
	"./alone.svg": 964,
	"./amazed.svg": 965,
	"./amused.svg": 966,
	"./angry.svg": 967,
	"./anticipation.svg": 968,
	"./anxiety.svg": 969,
	"./assured.svg": 970,
	"./crazy.svg": 971,
	"./depressed.svg": 972,
	"./disappointed.svg": 973,
	"./disgusted.svg": 974,
	"./excellent.svg": 975,
	"./fear.svg": 976,
	"./frustrated.svg": 977,
	"./generic.svg": 978,
	"./good.svg": 979,
	"./happy.svg": 980,
	"./inspired.svg": 981,
	"./joy.svg": 982,
	"./motivated.svg": 983,
	"./peaceful.svg": 984,
	"./pensive.svg": 985,
	"./poor.svg": 986,
	"./sad.svg": 987,
	"./surprise.svg": 988,
	"./terrible.svg": 989,
	"./thrilled.svg": 990,
	"./tiered.svg": 991,
	"./trust.svg": 992,
	"./upset.svg": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 708;